export default __webpack_public_path__ + "img/list8.c9716a2f.jpeg";